import { HttpParameterCodec, HttpHeaders } from '@angular/common/http';
import { Platform } from '@ionic/angular';
import { API } from '@app/core/models';

export class CustomEncoder implements HttpParameterCodec {
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}

export function getOptions(platform: Platform): API.HttpOptions {
  let options = {};
  if (!platform.is('capacitor')) {
    const headers = new HttpHeaders({
      Authorization: '',
    });
    options = {
      headers,
      withCredentials: true,
    };
  }
  return options;
}
